<template>
  <div class="upload-card">
    <div class="text-xs-center">
      <v-btn color="red lighten-2 text-center" dark @click="activateLoader">
        Upload File
      </v-btn>
    </div>

    <div ref="croppieCard" class="uploader">
      <form>
        <input
          type="file"
          name="uploadFieldName"
          ref="fileUploader"
          @change="filesChange($event.target.files)"
          accept="application/pdf"
          class="input-file"
        />
      </form>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import "croppie/croppie.css";
import Croppie from "croppie/croppie.js";
import firebase from "firebase/app";
import "firebase/storage";

export default {
  components: {},
  props: {
    width: {
      type: Number,
    },
    height: {
      type: Number,
    },
    path: {
      type: String,
    },
  },
  data: () => ({
    croppieObject: Object,
    file: {
      name: "",
      type: "",
    },
    fileList: {},
    croppingSRC: "",
    dialog: false,
    isInitial: true,
    isCropping: false,
    isSuccess: false,
  }),
  watch: {
    dialog: function(newValue, old) {
      if (!newValue) {
        this.reset();
      }
    },
  },
  methods: {
    activateLoader() {
      this.$refs.fileUploader.click();
    },
    async filesChange(fileList) {
      this.croppieObject = null;
      this.isInitial = false;
      this.isCropping = true;

      let self = this;

      if (!fileList.length) return;
      this.fileList = fileList;
      Array.from(Array(fileList.length).keys()).map((x) => {
        var storageRef = firebase.storage().ref();
        let fileRef = storageRef.child(
          "/" + self.$props.path + "/" + self.file.name + Date.now()
        );

        fileRef.put(self.fileList[x]).then((snapshot) => {
          snapshot.ref.getDownloadURL().then((downloadURL) => {
            self.file = downloadURL;
            this.$parent.$emit("uploadDoneFile", { url: downloadURL });
          });
        });
      });
    },
  },
};
</script>
<style lang="scss">
.upload-card {
  .cropping-container,
  .uploader {
    position: fixed;
    left: 100vw;
    overflow: hidden;
  }
}
</style>
